import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol as Your iPhone Apps Development Company in
              Dubai?
            </h2>
            <p>
              Learn why TekRevol stands out among iPhone app development
              companies in Dubai. With an established track record of offering
              innovative solutions, our team merges skill and creativity to
              bring your ideas to life. From a simple spark to the launching of
              project, we prioritize transparency, communication, and client
              approval, guaranteeing an effortless development process and
              exceptional outcomes for your iOS app venture. Want to learn more
              about us?
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <StaticImage
              src="../../images/location_new/fold7/ios-dubai.webp"
              alt="Android-app-developers-uk"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={525}
              height={804}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
